import { render, staticRenderFns } from "./FisicoquimicosModal.vue?vue&type=template&id=d6542da6&scoped=true&"
import script from "./FisicoquimicosModal.vue?vue&type=script&lang=js&"
export * from "./FisicoquimicosModal.vue?vue&type=script&lang=js&"
import style0 from "./FisicoquimicosModal.vue?vue&type=style&index=0&id=d6542da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6542da6",
  null
  
)

export default component.exports